import { getConfigurationNoCustoms } from './shipment';

export const getReturnConfiguration = (shippingConfig, { defaultDimensionUnit }) => {
  const baseConfiguration = getConfigurationNoCustoms(shippingConfig, defaultDimensionUnit);
  if (baseConfiguration?.options) {
    // this fixes an issue with confirmation applying correct
    // and was copied from #3690
    baseConfiguration.options.confirmation =
      baseConfiguration.options?.confirmation?.confirmationId || baseConfiguration.options?.confirmationEnumId;
  }
  return {
    ...baseConfiguration,
    customs: null,
    shipDate: null,
    isReturn: true,
  };
};
